import * as Yup from "yup";

export const ReportLinkSchema = Yup.object({
    reportEmail:Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
});
export const AttachmentSchema = Yup.object({
    attachmentEmail: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
});


export const ReportAndAttachmentSchema = Yup.object({
    reportEmail: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
    attachmentEmail :Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      'Invalid email address'
    )
    .required('Email is required'),
});

export const WhatsAppSchema = Yup.object({
  whatsappNumber: Yup.string()
    .matches(/^\+?[0-9]{8,15}$/, "Invalid phone number")
    .required("Number is required"),
});

// If you allow sending the PDF to either email OR WhatsApp (or both)
// validate only the fields that are actually selected.
export const AttachmentOrWhatsAppSchema = Yup.object({
  attachmentEmail: Yup.string()
    .when("$needsEmail", {
      is: true,
      then: (s) =>
        s
          .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
            "Invalid email address"
          )
          .required("Email is required"),
      otherwise: (s) => s.notRequired(),
    }),
  whatsappNumber: Yup.string().when("$needsPhone", {
    is: true,
    then: (s) => s.matches(/^\+?[0-9]{8,15}$/, "Invalid phone number").required("Number is required"),
    otherwise: (s) => s.notRequired(),
  }),
});